import type React from 'react';

import type { TransitionCopy } from './transition-users-modal.constants';

import { Box } from 'ui/box';

interface TransitionConfirmStepProps {
  copy: TransitionCopy;
}

const TransitionConfirmStep = ({
  copy,
}: TransitionConfirmStepProps): React.JSX.Element => (
  <Box sx={{ mt: 0.5 }}>{copy.body}</Box>
);

export default TransitionConfirmStep;
